import React from "react";
import { TextField, Typography } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import StyledAutocomplete from "components/StyledAutocomplete";
import { SimpleLensView } from "generated/graphql";

export interface LensAutocompleteProps {
  options: SimpleLensView[];
  selectedLens: SimpleLensView | undefined;
  onChange: (lens: SimpleLensView | undefined) => void;
  disabled?: boolean;
  className?: string;
}

const LensAutocomplete = (props: LensAutocompleteProps) => {
  const renderLens = (props: React.HTMLAttributes<HTMLLIElement>, lens: SimpleLensView) => {
    return (
      <li {...props} key={lens.id}>
        <Typography noWrap variant="subtitle2">
          {lens.name}
        </Typography>
      </li>
    );
  };

  return (
    <StyledAutocomplete<SimpleLensView, false, false, false>
      className={props.className}
      freeSolo={false}
      multiple={false}
      disabled={props.disabled}
      autoHighlight
      autoComplete
      size="small"
      style={{ fontSize: "0.8rem" }}
      fullWidth
      options={props.options}
      value={props.selectedLens || null}
      onChange={(_evt, item) => {
        props.onChange(item || undefined);
      }}
      renderOption={renderLens}
      getOptionLabel={(l: SimpleLensView) => l.name}
      filterOptions={createFilterOptions({
        ignoreCase: true,
        matchFrom: "any",
        stringify: (l: any) => l.name,
      })}
      renderInput={(params) => <TextField {...params} label="Choose Lens" fullWidth />}
    />
  );
};

export default LensAutocomplete;
